import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as firebase from 'firebase/app';
import 'firebase/storage'
import { AuthService } from '../../services/auth/auth.service';
import { WindowService } from '../../services/window/window.service';
import { AngularFireDatabase } from 'angularfire2/database';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AngularFireAuth } from 'angularfire2/auth';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { Observable } from 'rxjs/Rx';
import { User } from '../datamodel/user';
import { UploadService } from '../../uploads/shared/upload.service';
import { Upload } from '../../uploads/shared/upload';
import { ReCaptchaModule } from 'angular2-recaptcha';

@Component({
    selector: 'app-register',
    templateUrl: './register.component.html',
    styleUrls: ['./register.component.scss'],
    providers: [WindowService]
})
export class RegisterComponent implements OnInit {

    title = 'SIGN UP';

    @ViewChild('hospname') hospname: ElementRef;

    private usersCollection: AngularFirestoreCollection<User>;
    users: Observable<User[]>;

    public lastError: string = null;
    public lastErrorPhone: string = null;

    public sentPhoneValidation: boolean = false;
    windowRef: any;

    private logoFileURL = "";

    imgURL = "";

    constructor(public auth: AuthService, public afAuth: AngularFireAuth, private win: WindowService, private afs: AngularFirestore, private upSvc: UploadService, public router: Router) {

    }

    selectedFiles: FileList;
    currentUpload: Upload;
    private basePath: string = '/uploads';
    uploads: Observable<Upload[]>;

    detectFiles(event) {
        this.selectedFiles = event.target.files;
        this.uploadLogo();
    }

    pushUploadLogo(upload: Upload) {
        let storageRef = firebase.storage().ref();
        let filename = Math.random().toString(36).split('').filter(function (value, index, self) {
            return self.indexOf(value) === index;
        }).join('').substr(2, 12);
        let uploadTask = storageRef.child(this.basePath + "/" + filename + upload.file.name).put(upload.file);
        uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED,
            (snapshot) => {
                // upload in progress
                upload.progress = (uploadTask.snapshot.bytesTransferred / uploadTask.snapshot.totalBytes) * 100
            },
            (error) => {
                // upload failed
                console.log(error)
            },
            () => {
                // upload success
                upload.url = uploadTask.snapshot.downloadURL
                upload.name = upload.file.name
                this.upSvc.saveFileData(upload);
                this.logoFileURL = upload.url;
                this.imgURL = upload.url;
            }
        );
    }

    uploadLogo() {
        let file = this.selectedFiles.item(0);
        this.currentUpload = new Upload(file);
        this.pushUploadLogo(this.currentUpload);
    }

    deleteLogo() {
        let file = this.selectedFiles.item(0);
        this.currentUpload = new Upload(file);
        this.upSvc.deleteUpload(this.currentUpload);
        this.imgURL = "";
    }

    signup() {
        this.lastError = null;
        console.log(this.logoFileURL);
        var hname = this.hospname.nativeElement.value(' ', '');
        this.afs.collection('institutions').doc(hname).set({
            name: this.hospname.nativeElement.value,
            logo: this.logoFileURL
        })
        .then(value => {
            console.log('Success!', value);

        })
        .catch((err) => {
            console.log('Something went wrong:', err.message);
            return Promise.reject(err);
        });
    }

    signupVerify() {
        /*this
            .windowRef
            .confirmationResult
            .confirm(this.email.nativeElement.value)
            .then(this.auth.verify)
            .catch(error => {
                console.log(error);
                this.lastErrorPhone = 'Incorrect verification code entered.'
            });*/
    }

    uploadImage() {

    }

    ngOnInit() {

    }

}



// WEBPACK FOOTER //
// ./src/app/modules/register/register.component.ts